jQuery.validator.addMethod("exactlength", function(value, element, param) {
    return this.optional(element) || value.length == param;
}, jQuery.validator.format("Please enter exactly {0} characters."));

jQuery.validator.addMethod("phone", function(value, element) {
    return /^[0-9+][0-9 ]{7,17}$/.test(value) || value == '';
}, jQuery.validator.format("Please enter valid phone number."));

jQuery.validator.addMethod("digitsWithSpaces", function (value, element) {
    return /^[0-9\s]*$/.test(value) || value == '';
}, jQuery.validator.format("Please enter valid post code."));